import { render, staticRenderFns } from "./XSFlipCard.vue?vue&type=template&id=41517ec6&scoped=true&"
import script from "./XSFlipCard.vue?vue&type=script&lang=js&"
export * from "./XSFlipCard.vue?vue&type=script&lang=js&"
import style0 from "./XSFlipCard.vue?vue&type=style&index=0&id=41517ec6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41517ec6",
  null
  
)

export default component.exports